import axios from "axios";

export default {
    state: {
        farm_groups: []
    },
    getters: {
        farmGroups: state => {
            return state.farm_groups;
        }
    },
    mutations: {
        SET_FARM_GROUPS(state, farm_groups) {
            state.farm_groups = farm_groups;
        }
    },
    actions: {
        GET_FARM_GROUPS: ({ commit, getters }) => {
            if(getters.farmGroups.length == 0) {
                axios.get("/drugs/farm-groups")
                    .then(response => {
                        console.log(response.data);
                        commit('SET_FARM_GROUPS', response.data.farm_groups);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
}